import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ListFooterContext = createContext(null);

function samePaginationData(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  return (
    a.page === b.page &&
    a.pageCount === b.pageCount &&
    a.pageSize === b.pageSize &&
    a.canPrev === b.canPrev &&
    a.canNext === b.canNext &&
    a.className === b.className
  );
}

/**
 * Holds optional list pagination for the always-on sticky Jet footer.
 * When null, Rows / page nav stay invisible but Jet remains available.
 */
export function ListFooterProvider({ children }) {
  const [pagination, setPaginationState] = useState(null);

  const setPagination = useCallback((next) => {
    setPaginationState((prev) => {
      if (next == null) return null;
      if (samePaginationData(prev, next)) {
        // Refresh handlers without a re-render (avoids loops from new function identities).
        prev.onPageSizeChange = next.onPageSizeChange;
        prev.onPrev = next.onPrev;
        prev.onNext = next.onNext;
        prev.jetActions = next.jetActions;
        return prev;
      }
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({
      pagination,
      setPagination,
    }),
    [pagination, setPagination]
  );

  return <ListFooterContext.Provider value={value}>{children}</ListFooterContext.Provider>;
}

export function useListFooter() {
  return useContext(ListFooterContext);
}
